import * as React from "react";

import type { SpendFamilySummary } from "@/types/spend";
import { sanitizeSpendProfileHtml } from "./spend-profile-html";

const PROFILE_TABLE_CLASSES =
  "overflow-x-auto text-sm text-gray-700 [&_caption]:pb-2 [&_caption]:text-left [&_caption]:text-xs [&_caption]:text-gray-500 [&_table]:w-full [&_table]:border-collapse [&_td]:border-t [&_td]:border-[#ebe5de] [&_td]:px-3 [&_td]:py-2 [&_td]:tabular-nums [&_th]:bg-[#f7f2ec] [&_th]:px-3 [&_th]:py-2 [&_th]:text-left [&_th]:text-xs [&_th]:font-semibold [&_th]:text-gray-600";

const FamilySpendProfile = ({ family, showName }: { family: SpendFamilySummary; showName: boolean }) => {
  const html = React.useMemo(
    () => (family.spend_profile_html ? sanitizeSpendProfileHtml(family.spend_profile_html) : ""),
    [family.spend_profile_html],
  );
  if (!html) return null;
  return (
    <article aria-label={`${family.name} spend profile`} className="px-5 py-4">
      {showName ? <h3 className="mb-2 text-sm font-semibold text-[#111b35]">{family.name}</h3> : null}
      <div className={PROFILE_TABLE_CLASSES} dangerouslySetInnerHTML={{ __html: html }} />
    </article>
  );
};

interface Props {
  families: SpendFamilySummary[];
}

export const SpendProfile = ({ families }: Props) => {
  const withProfile = families.filter(family => family.spend_profile_html);
  if (withProfile.length === 0)
    return (
      <p className="px-5 py-10 text-center text-sm text-gray-500">
        No spend profile is available in the contract summary for{" "}
        {families.length === 1 ? "this Contract Family" : "these Contract Families"}.
      </p>
    );
  return (
    <div className="divide-y divide-[#ebe5de]">
      {withProfile.map(family => (
        <FamilySpendProfile key={family.relation_id} family={family} showName={families.length > 1} />
      ))}
    </div>
  );
};
